import {
  APP_COLOR,
  APP_HOVER_COLOR,
  FONT_FAMILY,
} from "../../theme";

export const styles = {
  button: {
    borderRadius: "var(--radius-md, 8px)",
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
    marginTop: "10px",
    height: "40px",
    padding: "0px 10px 0px 10px"
  } as const,
  tabContainer: {
    width: "100%",
    typography: "body1",
    borderRadius: "10px",
    height: "53vh",
  } as const,
  tab: {
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "17px",
  } as const,
  selectField: {
    width: "93%",
    border: "blue",
    borderRadius: "5px",
    color: "white",
  } as const,
  filterSortContainer: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  } as const,
};
